// Module
var code = "<template class=\"comp-dynamic-view\"> <div class=\"comp-dynamic-view--slot\" element.ref=\"dynamicViewSlotElem\"></div> </template> ";
// Exports
module.exports = code;